import React, { useState } from 'react';
export var BackLinkContext = React.createContext({});
var BackLinkProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), backLinkProps = _b[0], setBackLinkProps = _b[1];
    return (React.createElement(BackLinkContext.Provider, { value: {
            backLinkProps: backLinkProps,
            setBackLinkProps: setBackLinkProps,
        } }, children));
};
export default BackLinkProvider;
export var BackLinkConsumer = BackLinkContext.Consumer;
